import { Tooltip } from '@fluentui/react-components';
import React from 'react';
import { IconTooltip } from '../../../../components/IconTooltip/IconTooltip';
import { injectIntlAndObserver } from '../../../../utils';
import { getClassNames } from './MetricMarker.styles';
import { IMetricMarkerIntlProps } from './MetricMarker.types';

export const MetricMarker = injectIntlAndObserver(
  ({ color, metricData, metricName, isActive, isIncompatible, incompatibleTooltipCantText, onClick }: IMetricMarkerIntlProps) => {
    const { contentStyle, marker, markerData, markerName, markerWrapper, tooltip } = getClassNames({ color, isActive, isIncompatible });

    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick?.();
      }
    };
    return (
      <div
        onClick={!isIncompatible ? onClick : undefined}
        className={markerWrapper}
        tabIndex={isIncompatible ? -1 : 0}
        onKeyDown={handleKeyDown}
      >
        <div className={marker} />
        <div className={contentStyle}>
          <span className={markerData}>
            {isIncompatible || !metricData ? '- -' : metricData}
            {isIncompatible && (
              <span className={tooltip}>
                <IconTooltip tooltipMessage={incompatibleTooltipCantText || ''} iconName={'warning'} />
              </span>
            )}
          </span>
          <Tooltip content={metricName} relationship="label">
            <span className={markerName}>{metricName}</span>
          </Tooltip>
        </div>
      </div>
    );
  }
);
